import React from 'react';

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-opacity-50 flex items-center justify-center z-50 ">
      <div className="bg-white p-8 rounded-[20px] shadow-lg md:w-[400px]">
        {children}
      </div>
    </div>
  );
};

export default Modal;